import tabView from './tabComponent.html';
import './tabComponent.css';

export function tabComponent() {
	return {
		bindings: {
			label: '@',
			isOpen: '<?',
			isHidden: '<?',
		},
		require: {
			tabs: '^^shTabs',
		},
		transclude: true,
		controllerAs: 'vm',
		controller: tabComponentCtrl,
		template: tabView,
	};
}

export class tabComponentCtrl {
	constructor($element) {
		'ngInject';
		this.$element = $element;
	}

	$onInit() {
		this.setState(this.isOpen);
		this.tabs.registerTab(this);
	}

	setState(openOrClosed) {
		this.isOpen = openOrClosed;
		this.$element[openOrClosed ? 'addClass' : 'removeClass']('is-open');
	}

	$onDestroy() {
		this.tabs.unregisterTab(this);
	}
}
